import { createSelector } from 'reselect';
import { get } from '~/utils/object';

export const getState = (state: any) => state.login;

export const getLoginUsername = createSelector([getState], state =>
  get(state, 'username', ''),
);

export const isLoggedIn = createSelector(
  [getState],
  state => state.success || false,
);

export const getSamlRedirect = createSelector(
  [getState],
  state => state.samlRedirectUrl,
);
